/**
 * Automation Media Section
 *
 * Edit mode UI for configuring HOW the automation is delivered.
 * Used inline within AutomationCard when editing the "How" section.
 */

import { useFormikContext } from 'formik';
import { FC } from 'react';
import { Box } from 'src/components/Box';
import { Checkbox } from 'src/components/Checkbox';

import { MediaOption, useAutomationMedia } from '../hooks/useAutomationMedia';
import { AutomationItem } from '../types';

interface AutomationMediaSectionProps {
  automation: AutomationItem;
  index: number;
}

export const AutomationMediaSection: FC<AutomationMediaSectionProps> = ({
  automation,
  index,
}) => {
  const { setFieldValue } = useFormikContext();
  const { media, mediaOptions } = useAutomationMedia(automation);

  const handleMediaToggle = (mediaType: MediaOption) => {
    const currentMedia = automation.media || [];
    const newMedia = currentMedia.includes(mediaType)
      ? currentMedia.filter((m) => m !== mediaType)
      : [...currentMedia, mediaType];

    setFieldValue(`automations.${index}.media`, newMedia);
  };

  return (
    <Box display="flex" flexWrap="wrap" gap={2}>
      {mediaOptions.map((option) => (
        <Checkbox
          key={option.value}
          label={option.label}
          checked={media.includes(option.value)}
          onChange={() => handleMediaToggle(option.value)}
        />
      ))}
    </Box>
  );
};
